export { default, default as ErrorBoundary } from './ErrorBoundary';
